module.exports = __webpack_public_path__ + "static/media/logingov_logo_white.d64952a6.svg";